import { ApiError } from '@fetmode/api-client';

export interface RoomBanOverlayState {
  permanent: boolean;
  payToUnbanAllowed: boolean;
  unbanPriceCoins: number | null;
  cooldownUntil: string | null;
  strikes: number;
}

function readString(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

function readNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

function readBoolean(value: unknown): boolean {
  return value === true;
}

export function parseRoomBanDetails(
  details: Record<string, unknown> | undefined,
): RoomBanOverlayState {
  return {
    permanent: readBoolean(details?.permanent),
    payToUnbanAllowed: readBoolean(details?.payToUnbanAllowed),
    unbanPriceCoins: readNumber(details?.unbanPriceCoins),
    cooldownUntil: readString(details?.cooldownUntil),
    strikes: readNumber(details?.strikes) ?? 0,
  };
}

export type JoinRestrictionResult =
  | { kind: 'banned'; details: RoomBanOverlayState; message: string }
  | { kind: 'kicked'; until: string | null; message: string }
  | { kind: 'other'; message: string };

export function parseJoinRestriction(err: unknown): JoinRestrictionResult {
  if (err instanceof ApiError && err.code === 'ROOM_BANNED') {
    return {
      kind: 'banned',
      details: parseRoomBanDetails(err.details),
      message: err.message,
    };
  }
  if (err instanceof ApiError && err.code === 'KICKED_FROM_SHOW') {
    return {
      kind: 'kicked',
      until: readString(err.details?.until),
      message: err.message,
    };
  }
  return {
    kind: 'other',
    message: err instanceof ApiError ? err.message : 'Unable to join this show.',
  };
}
